// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v3.21.12
// source: voteairecommendation.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "voteairecommendation";

export interface VoteAIRecommendationRequest {
  caseId: string;
  aiRecommendationId: string;
}

export interface VoteAIRecommendationResponse {
  success: boolean;
}

function createBaseVoteAIRecommendationRequest(): VoteAIRecommendationRequest {
  return { caseId: "", aiRecommendationId: "" };
}

export const VoteAIRecommendationRequest: MessageFns<VoteAIRecommendationRequest> = {
  encode(message: VoteAIRecommendationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.caseId !== "") {
      writer.uint32(10).string(message.caseId);
    }
    if (message.aiRecommendationId !== "") {
      writer.uint32(18).string(message.aiRecommendationId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoteAIRecommendationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoteAIRecommendationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.caseId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.aiRecommendationId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoteAIRecommendationRequest {
    return {
      caseId: isSet(object.caseId)
        ? globalThis.String(object.caseId)
        : isSet(object.case_id)
        ? globalThis.String(object.case_id)
        : "",
      aiRecommendationId: isSet(object.aiRecommendationId)
        ? globalThis.String(object.aiRecommendationId)
        : isSet(object.ai_recommendation_id)
        ? globalThis.String(object.ai_recommendation_id)
        : "",
    };
  },

  toJSON(message: VoteAIRecommendationRequest): unknown {
    const obj: any = {};
    if (message.caseId !== "") {
      obj.caseId = message.caseId;
    }
    if (message.aiRecommendationId !== "") {
      obj.aiRecommendationId = message.aiRecommendationId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VoteAIRecommendationRequest>, I>>(base?: I): VoteAIRecommendationRequest {
    return VoteAIRecommendationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VoteAIRecommendationRequest>, I>>(object: I): VoteAIRecommendationRequest {
    const message = createBaseVoteAIRecommendationRequest();
    message.caseId = object.caseId ?? "";
    message.aiRecommendationId = object.aiRecommendationId ?? "";
    return message;
  },
};

function createBaseVoteAIRecommendationResponse(): VoteAIRecommendationResponse {
  return { success: false };
}

export const VoteAIRecommendationResponse: MessageFns<VoteAIRecommendationResponse> = {
  encode(message: VoteAIRecommendationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoteAIRecommendationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoteAIRecommendationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoteAIRecommendationResponse {
    return { success: isSet(object.success) ? globalThis.Boolean(object.success) : false };
  },

  toJSON(message: VoteAIRecommendationResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VoteAIRecommendationResponse>, I>>(base?: I): VoteAIRecommendationResponse {
    return VoteAIRecommendationResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VoteAIRecommendationResponse>, I>>(object: I): VoteAIRecommendationResponse {
    const message = createBaseVoteAIRecommendationResponse();
    message.success = object.success ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
